export default "__VITE_ASSET__Che0g8tX__"